const integral = [{
    path: '/integral/detail',
    name: 'IntegralDetail',
    component: () =>
        import('../views/integral/IntegralDetail.vue'),
    meta: {
        title: '明细',
    }
},
{
    path: '/integral/rule',
    name: 'IntegralRule',
    component: () =>
        import('../views/integral/IntegralRule.vue'),
    meta: {
        title: '规则说明',
    }
},
{
    path: '/integral/earn',
    name: 'IntegralEarn',
    component: () =>
        import('../views/integral/IntegralEarn.vue'),
    meta: {
        title: '赚取',
    }
},
{
    path: '/integral/store',
    name: 'IntegralStore',
    component: () =>
        import('../views/integral/IntegralStore.vue'),
    meta: {
        title: '商城'
    }
},
{
    path: '/integral/store/search',
    name: 'IntegralStoreSearch',
    component: () =>
        import('../views/integral/IntegralStoreSearch.vue'),
    meta: {
        title: '商城搜索'
    }
},
{
    path: '/integral/goods/:id',
    name: 'IntegralGoodsDetail',
    component: () =>
        import('../views/integral/IntegralGoodsDetail.vue'),
    meta: {
        title: '商品详情'
    }
},
{
    path: '/integral/record',
    name: 'IntegralRecord',
    component: () =>
        import('../views/integral/IntegralRecord.vue'),
    meta: {
        title: '兑换记录'
    }
}
]

export default integral